import { render, staticRenderFns } from "./MessageBoxHeader.vue?vue&type=template&id=22c4e5e5&scoped=true"
import script from "./MessageBoxHeader.vue?vue&type=script&lang=js"
export * from "./MessageBoxHeader.vue?vue&type=script&lang=js"
import style0 from "./MessageBoxHeader.vue?vue&type=style&index=0&id=22c4e5e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4e5e5",
  null
  
)

export default component.exports